import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import { BillRates } from 'pages/BillRates/types'

type GetBillRatesRequest = {
  page: number
  pageSize: number
  companyId?: number
  positionId?: number
  includeDeleted?: boolean
}

type GetBillRatesResponse = {
  items: BillRates
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export const getBillRates = async (
  request: GetBillRatesRequest
): Promise<GetBillRatesResponse> => {
  const response = await api.get<GetBillRatesResponse>('/admin/bill_rate', {
    params: {
      page: request.page,
      pageSize: request.pageSize,
      companyId: request.companyId,
      positionId: request.positionId,
      includeDeleted: request.includeDeleted,
    },
    paramsSerializer: queryParamSerializer,
  })
  return response.data
}
